let module = angular.module('app.resources');

module.factory('Order', ($resource) => {
  'ngInject';

  var Order = $resource(
    `${API_ROOT}/account/orders/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
      },
    }
  );

  return Order;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/order.js